{
  "base": {
    "title": "Quelque chose s'est mal passé",
    "subtitle": "Nous vous remercions de votre patience pendant que nous travaillons sur le correctif.",
    "redirectLabel": "Aller à la page d'accueil",
    "helpCenterLink": "Visiter le centre d'aide"
  }
}
